export const getStatusText = (status: number) => {
  switch (status) {
    case 0:
      return 'None';
    case 1:
      return 'Storage';
    case 2:
      return 'Service';
    case 3:
      return 'Processing';
    case 4:
      return 'Delivered';
    case 5:
      return 'Awaiting to be Ordered';
    case 6:
      return 'Product Ordered';
    case 7:
      return 'Product in Transit';
    case 8:
      return 'Product Received';
    case 9:
      return 'To Delete';
    default:
      return 'Unknown';
  }
};
